<div class="sidebar-wrapper tertiary-bg-color">
  <div class="cbm-logo">
    <div class="cbm-content">
      <!--<img src="assets/img/cbm_admin_navbar2.svg" class="cbmLogo" alt="cbm_logo">-->
      <img src="assets/img/cbm_admin_navbar2.svg" class="cbmLogo">
      <!--<span>CBM</span>-->
    </div>
  </div>

  <ul class="nav" >
    <div class="activeUser font-bold text-center primary-font-size" style="color: #171C8F;">
      <span style="color: #171C8F; font-family: 'TradeGothic_LT_Bold'; font-size: 24px;">
        {{userScreenName}}
      </span><br>
      <span style="font-family: 'HelveticaNeue-Regular'; font-size: 13px; color: #797A7B;">
        {{userType}}
      </span>
    </div>

    <li class="top-divider">

    </li>

    @if (isDefault) {
      <span>
        @for (menuItem of menuItems; track menuItem; let i = $index) {
          <li routerLinkActive="active" (click)="dropClick(menuItem.title, 'subIcon' + i)" class="sidebar-item" style="background-color: #FFFFFF;">
            <a [routerLink]="[menuItem.path]">
              <!--<div *ngIf="i != menuItems.length-1">-->
              <img class="sidebar-icon" id="{{ 'mainIcon' + i }}" [src]="menuItem.icon">
              <span class="menuItem" id="mainItem{{ i }}" (mouseover)="onHover($event)" (mouseout)="offHover($event)" style="font-family: 'HelveticaNeue' !important;">{{menuItem.title}}</span>
              @if (menuItem.children) {
                <img id="{{ 'subIcon' + i }}" class="sidebar-icon-sub" [src]="menuItem.submenuicon">
              }
              <!--img *ngIf="menuItem.children && menuItem.children.length > 2" id="subIcon1" class="sidebar-icon-sub" [src]="menuItem.submenuicon"-->
            <!--</div>-->
            <!--<div *ngIf="i == menuItems.length-1" >
            <li class="bottom-divider" style="padding-bottom: 30px; padding-top: -10px;">
            </li>
            <img class="sidebar-icon" id="{{ 'mainIcon' + i }}" [src]="menuItem.icon">
            <span class="menuItem" id="mainItem{{ i }}" (mouseover)="onHover($event)" (mouseout)="offHover($event)" style="font-family: 'HelveticaNeue' !important;">{{menuItem.title}}</span>
          </div>-->
        </a>
        @if (menuItem.children && menuItem.children.length == 2 && dropShow == true) {
          <ul class="nav" (click)="$event.stopPropagation()" >
            @for (childmenu of menuItem.children; track childmenu; let i = $index) {
              <li routerLinkActive="active" class="{{menuItem.class}} nav-item">
                <a class="nav-link" [routerLink]="[childmenu.path]">
                  <p class="menuChildren" id="menuChild{{i}}" (click)="onChangeClass(i,'menuChildren2')" >{{childmenu.title}}</p>
                </a>
              </li>
            }
          </ul>
        }
        @if (menuItem.children && menuItem.children.length > 2 && dropShow2 == true) {
          <ul class="nav" (click)="$event.stopPropagation()" >
            @for (childmenu of menuItem.children; track childmenu; let i = $index) {
              <li routerLinkActive="active" class="{{menuItem.class}} nav-item">
                <a class="nav-link" [routerLink]="[childmenu.path]">
                  <p class="menuChildren" id="menuChild{{i}}" (click)="onChangeClass(i,'menuChildren2')" >{{childmenu.title}}</p>
                </a>
              </li>
            }
          </ul>
        }
      </li>
    }
  </span>
}

@if (!isDefault) {
  <span>
    @for (menuItem of menuItems; track menuItem; let i = $index) {
      <li routerLinkActive="active"
        (click)="dropClick(menuItem.title, 'subIcon' + i)"
        class="sidebar-item" style="background-color: #FFFFFF;">
        <a  [routerLink]="menuItem.children?.length ? undefined : [menuItem.path]">
          <!--<div *ngIf="i != menuItems.length-1">-->
          <img class="sidebar-icon" id="{{ 'mainIcon' + i }}" [src]="menuItem.icon">
          <span class="menuItem" id="mainItem{{ i }}" (mouseover)="onHover($event)" (mouseout)="offHover($event)" style="font-family: 'HelveticaNeue' !important;">{{menuItem.title}}</span>
          @if (menuItem.children) {
            <img id="{{ 'subIcon' + i }}" class="sidebar-icon-sub" [src]="menuItem.submenuicon">
          }
          <!--img *ngIf="menuItem.children && menuItem.children.length > 2" id="{{ 'subIcon' + i }}" class="sidebar-icon-sub" [src]="menuItem.submenuicon"-->
        <!--</div>-->
        <!--<div *ngIf="i == menuItems.length-1" >
        <li class="bottom-divider" style="padding-bottom: 30px; padding-top: -10px;">
        </li>
        <img class="sidebar-icon" id="{{ 'mainIcon' + i }}" [src]="menuItem.icon">
        <span class="menuItem" id="mainItem{{ i }}" (mouseover)="onHover($event)" (mouseout)="offHover($event)" style="font-family: 'HelveticaNeue' !important;">{{menuItem.title}}</span>
      </div>-->
    </a>
    @if (menuItem.children && menuItem.children.length == 2 && dropShow == true) {
      <ul class="nav" (click)="$event.stopPropagation()" >
        @for (childmenu of menuItem.children; track childmenu; let i = $index) {
          <li routerLinkActive="active" class="{{menuItem.class}} nav-item">
            <a class="nav-link" [routerLink]="[childmenu.path]">
              <p class="menuChildren" id="menuChild{{i}}" (click)="onChangeClass(i,'menuChildren2')" >{{childmenu.title}}</p>
            </a>
          </li>
        }
      </ul>
    }
    <!-- DEVNOTE: In investigation -->
    @if (menuItem.children && menuItem.children.length > 2 && dropShow2 == true) {
      <ul class="nav" (click)="$event.stopPropagation()" >
        @for (childmenu of menuItem.children; track childmenu; let i = $index) {
          <li routerLinkActive="active" class="{{menuItem.class}} nav-item">
            <a class="nav-link" [routerLink]="[childmenu.path]">
              <p class="menuChildren" id="menuChild{{i}}" (click)="onChangeClass(i,'menuChildren2')" >{{childmenu.title}}</p>
            </a>
          </li>
        }
      </ul>
    }
  </li>
}
</span>
}

<!--<li class="bottom-divider">

</li>-->
<li class="sidebar-item">
  <!--<a (click)="onClickChangePass()">
  <img class="sidebar-icon" src="../../../../assets/img/icons/new_icons/069-log-in.svg">
  <span class="menuItem">Change Password</span>
</a>-->
<a (click)="onClickLogout()">
  <img class="sidebar-icon" src="../../../../assets/img/icons/new_icons/069-log-in.svg">
  <span class="menuItem">Log out</span>
</a>
</li>
</ul>
</div>
